import { useState } from "react";
import defaultBanner from "../assets/expligo_wp2.png";
import { IconButton } from "../atoms/buttons";
import { TitleAtom } from "../atoms/titleAtom";
import { HorizontalLayout, VerticalLayout } from "../components/layout";
import { icon } from "../functions/icons";
import CourseAiDescription from "./CourseAiDescription";
import { color } from "chart.js/helpers";
import { position } from "polished";

export const SelectImageComp = ({ openSelector, url, disabled, title, description, courseData}) => {
    const [expanded, setExpanded] = useState(false);
  return (
    <VerticalLayout
      onClick={disabled ? null : openSelector}
      className={`image-selector-comp ${expanded ? "open" : "closed"}`}
      style={{
        cursor: disabled ? "unset" : "pointer",
        position: "relative",
        display: "inline-block"
      }}
    >
      <img
        className="thumb-img"
        src={url || defaultBanner}
        alt="Afbeelding"
        style={{ display: "block", width: "100%" }}
      />
     {!url && !disabled && <TitleAtom style={{ width: "unset", top: "50%", left: "50%", transform: "translate(-50%, -50%)", position: "absolute"}} className={"white-color pick-photo"} title={"Kies afbeelding"}/>}

      <VerticalLayout onClick={() => { setExpanded(!expanded);}} style={{ height: "unset", width: "auto", }} className="image-overlay">
        <HorizontalLayout>
            <TitleAtom style={{ width: "unset", }} className={"img-course-title"} title={title}/>
           {(courseData?.description?.length > 250) && <IconButton style={{ height: "unset", }} size={50} color={"white-color"} className={`dropdown-chevron ${expanded ? "open" : "closed"}`} icon2={"chevron-down"}/>}
        </HorizontalLayout>
        <CourseAiDescription
          description={description}
          courseData={courseData}
          collapsible={true}
          expanded={expanded}
        />
      </VerticalLayout>
    </VerticalLayout>
  );
};
